import Immutable from 'seamless-immutable';

import * as chartActionTypes from '../../constants/chart-action-types';
import updateDocument from '../../util/updateDocument';
import * as utils from './documents.utils';

// TODO: review Immutable usage for other reducers
const initialState = Immutable({
  items: {},
  active: null,
  selectedPoint: null,
});

function documentsReducer(state = initialState, action) {
  switch (action.type) {
    case chartActionTypes.CREATE_CHART:
      return utils.createChart(state);
    case chartActionTypes.IMPORT_CHART:
      return utils.importChart(state, action);
    case chartActionTypes.DESTROY_CHART:
      return initialState;
    case chartActionTypes.DELETE_CHART:
      return utils.deleteChart(state, action);
    case chartActionTypes.REQUEST_CHART:
      return utils.requestChart(state, action);
    case chartActionTypes.RECEIVE_CHART:
      return utils.receiveChart(state, action);
    case chartActionTypes.CREATE_CHART_COMPLETE_DUPLICATE:
      return utils.createChartCompleteDuplicate(state, action);
    case chartActionTypes.CREATE_CHART_COMPLETE:
    case chartActionTypes.UPDATE_CHART_COMPLETE:
      return utils.saveChartComplete(state, action);
    case chartActionTypes.PUBLISH_START:
      return utils.publishStart(state, action);
    case chartActionTypes.PUBLISH_STEP:
      return utils.publishStep(state, action);
    case chartActionTypes.PUBLISH_COMPLETE:
      return utils.publishComplete(state, action);
    // Otherwise, update the attributes of a specific chart.
    default: {
      const id = action.documentId || state.active;
      const activeDoc = state.active ? state.items[id] : null;
      if (activeDoc) {
        const docUpdated = updateDocument(activeDoc, action);
        if (docUpdated) {
          state = state.setIn(['items', id], docUpdated);
        }
      }
      break;
    }
  }
  return state;
}

export default documentsReducer;
